import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import cx from 'classnames';
import { stringify as queryStringify } from 'querystring';

@connect((store) => {
  const searchQuery = store.routing.locationBeforeTransitions.query.search;
  return {
    search: searchQuery && [].concat(searchQuery) || []
  };
})
export default class NavColumn extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    navGroups: PropTypes.array.isRequired,
    navItems: PropTypes.object.isRequired,
    baseUrl: PropTypes.string.isRequired,
    navColumnState: PropTypes.string,
    search: PropTypes.array,
    title: PropTypes.string
  }

  constructor(props, context) {
    super(props, context);
  }

  changeNavColumnState(newColumnState) {
    this.props.dispatch(push(`${this.props.baseUrl}/${newColumnState}${this.props.search.length ? `?${queryStringify({search: this.props.search})}` : ''}`));
  }

  render() {
    return (
      <div className='nav-column'>
        <h3>{this.props.title}</h3>
        <ul>
          {
            this.props.navGroups.map((statusGroup, index) =>
              this.props.navItems
              &&
              <li className={cx({active: !this.props.navColumnState && index===0 || this.props.navColumnState===statusGroup})}
                  key={index}
                  data-id={statusGroup}
                  onClick={this.changeNavColumnState.bind(this, statusGroup)}>
                <div className='label'>{statusGroup}</div>
                <div className='count' data-id={`${statusGroup} Count`}>{this.props.navItems[statusGroup] && (this.props.navItems[statusGroup].total || this.props.navItems[statusGroup].length || 0)}</div>
              </li>
            )
          }
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/NavColumn/index.js